import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../BaseUrl";
import { UserContext } from "./User";
import { SettingsContext } from "./Settings";
import { toast } from "react-toastify";
//functions
import { getCookie, getApiUrl, getOffline, getSystemSettings } from "../functions/Functions";
import { parseFoodItems } from "../resources/restaurant/auth/pos/newpos/helpers";

//3rd party packages

// creating context api
const FoodContext = React.createContext();

const FoodProvider = ({ children }) => {
  const { authUserInfo } = useContext(UserContext);
  const { generalSettings } = useContext(SettingsContext)
  const history = useHistory();
  const abortControllerRef = React.useRef(null);
  // State hooks  here
  //loading
  const [loading, setLoading] = useState(false);
  const [isStockLoading, setIsStockLoading] = useState(false);
  const [dataPaginating, setDataPaginating] = useState(false);

  //website
  const [foodListWeb, setFoodListWeb] = useState(null);
  const [foodStockWeb, setFoodStockWeb] = useState(null);
  const [foodGroupWeb, setFoodGroupWeb] = useState(null);
  const [propertyGroupWeb, setPropertyGroupWeb] = useState(null);
  const [workPeriodWeb, setWorkPeriodWeb] = useState(null);
  const [onlineOrdersCustomer, setOnlineOrdersCustomer] = useState(null);

  //pos page online orders
  const [onlineOrdersAdmin, setOnlineOrdersAdmin] = useState(null);
  const [onlineOrdersAdminForSearch, setOnlineOrdersAdminForSearch] = useState(null);
    
  //pos page food panda orders
  const [foodPandaOrders, setFoodPandaOrders] = useState(null);
  const [foodPandaOrdersForSearch, setFoodPandaOrdersForSearch] = useState(null);

  //pos page pre orders
  const [preOrders, setPreOrders] = useState(null);
  const [preOrdersForSearch, setPreOrdersForSearch] = useState(null);
  //region
  const [regionList, setRegionList] = useState(null);
  const [regionForSearch, setRegionForSearch] = useState(null);
  const [regionForStatus, setRegionForStatus] = useState(null);
  //comment
  const [commentList, setCommentList] = useState(null);
  const [commentForSearch, setCommentForSearch] = useState(null);
  //comment type
  const [commentTypeList, setCommentTypeList] = useState(null);
  const [commentTypeForSearch, setCommentTypeForSearch] = useState(null);
  //sub category
  const [subCategoryList, setSubCategoryList] = useState(null);
  const [subCategoryForSearch, setSubCategoryForSearch] = useState(null);
  const [subCategoryForStatus, setSubCategoryForStatus] = useState(null);
  //food packing
  const [packingTypeList, setPackingTypeList] = useState(null);
  const [packingTypeForSearch, setPackingTypeForSearch] = useState(null);
  const [packingTypeForStatus, setPackingTypeForStatus] = useState(null);
  //tax group
  const [taxGroupList, setTaxGroupList] = useState(null);
  const [taxGroupForSearch, setTaxGroupForSearch] = useState(null);
  const [taxGroupForStatus, setTaxGroupForStatus] = useState(null);
  //Season
  const [seasonList, setSeasonList] = useState(null);
  const [seasonForSearch, setSeasonForSearch] = useState(null);
  const [seasonForStatus, setSeasonForStatus] = useState(null);
  //Generic
  const [genericList, setGenericList] = useState(null);
  const [genericForSearch, setGenericForSearch] = useState(null);
  const [genericForStatus, setGenericForStatus] = useState(null);

  //Flavor
  const [flavorList, setFlavorList] = useState(null);
  const [flavorForSearch, setFlavorForSearch] = useState(null);
  const [flavorForStatus, setFlavorForStatus] = useState(null);

  //Variant
  const [variantList, setVariantList] = useState(null);
  const [variantForSearch, setVariantForSearch] = useState(null);
  const [variantForStatus, setVariantForStatus] = useState(null);

  //weight
  const [weightList, setWeightList] = useState(null);
  const [weightForSearch, setWeightForSearch] = useState(null);
  const [weightForStatus, setWeightForStatus] = useState(null);

  //ProductionUnitList
  const [productionUnitList, setProductionUnitList] = useState(null);
  const [productionUnitForSearch, setProductionUnitForSearch] = useState(null);
  const [productionUnitForStatus, setProductionUnitForStatus] = useState(null);
  //Product type
  const [productTypeList, setProductTypeList] = useState(null);
  const [productTypeForSearch, setProductTypeForSearch] = useState(null);
  const [productTypeForStatus, setProductTypeForStatus] = useState(null);
  //food status
  const [foodStatusList, setFoodStatusList] = useState(null);
  const [foodStatusForSearch, setFoodStatusForSearch] = useState(null);
  const [foodStatusForStatus, setFoodStatusForStatus] = useState(null);
  //foods dept
  const [foodDeptList, setFoodDeptList] = useState(null);
  const [foodDeptForSearch, setFoodDeptForSearch] = useState(null);
  const [foodDeptForStatus, setFoodDeptForStatus] = useState(null);
  //meal time
  const [mealTimeList, setMealTimeList] = useState(null);
  const [mealTimeForSearch, setMealTimeForSearch] = useState(null);
  //foods
  const [foodList, setFoodList] = useState(null);
  const [foodForSearch, setFoodForSearch] = useState(null);

  //foods for pos
  const [foodForPOS, setFoodForPOS] = useState(null);
  const [menuForPos, setMenuForPos] = useState({});

  //food stock
  const [foodItemStock, setFoodItemStock] = useState(null);
  const [foodPurchaseHistory, setFoodPurchaseHistory] = useState(null);
  const [foodPurchaseHistoryForSearch, setFoodPurchaseHistoryForSearch] =
    useState(null);

  //food group
  const [foodGroupList, setFoodGroupList] = useState(null);
  const [foodGroupForSearch, setFoodGroupforSearch] = useState(null);
  const [foodGroupForSearchForPOS, setFoodGroupforSearchForPOS] =
    useState(null);
  const [foodGroupForPOSById, setFoodGroupForPOSById] =
    useState(null);

  //food unit
  const [foodUnitList, setFoodUnitList] = useState(null);
  const [foodUnitForSearch, setFoodUnitforSearch] = useState(null);

  //variation
  const [variationList, setVariationList] = useState(null);
  const [variationForSearch, setVariationForSearch] = useState(null);

  //property Group
  const [propertyGroupList, setPropertyGroupList] = useState(null);
  const [propertyGroupForSearch, setPropertyGroupForSearch] = useState(null);
  const [propertyGroupById, setPropertyGroupById] = useState(null);
  //property Item
  const [propertyItemList, setPropertyItemList] = useState(null);
  const [propertyItemForSearch, setPropertyItemForSearch] = useState(null);
  const [propertyItemGroup, setPropertyItemGroup] = useState(null);

  //stock
  let [items, setItems] = useState(null);
  let [theGroups, setTheGroups] = useState(null);
  let [itemsFood, setItemsFood] = useState(null);
  let [theGroupsFood, setTheGroupsFood] = useState(null);

  //food grops menu
  const [availableFoodGroups, setAvailableFoodGroups] = useState({});
  const [availableFoodGroupName, setAvailableFoodGroupName] = useState({});

  // localStorage helper
  const setDataToLocal = (url, res) => {
    try{
      localStorage.setItem(url, JSON.stringify(res));
    }catch(err){
      setLoading(false);
      console.log("err",err)
    }
  };

  // localStorage helper
  const getDataFromLocal = (url) => {
    return JSON.parse(localStorage.getItem(url));
  };

  //check if offline helper
  const offline = async(url) => {
    return localStorage.getItem(url) != null;
  };

  //useEffect- to get data on render
  useEffect(() => {
    async function fetchData(){
      // getFoodWeb();
      //call if authenticated
      if (getCookie() !== undefined || (await getOffline(BASE_URL + "/auth/user"))) {
        getFoodDept();
        getFoodItemsForPOS();
        getFoodGroup();
        getFoodGroupForPOS();
        getFoodUnit();
        getVariation();
        getPropertyGroup();
        getFoodGroupWithMenu();
        getPropertyItem()
      }
    }
    fetchData()
  }, []);

  // Helper
  const setIngredientsStock = (res) => {
    setItems(res.data[0]);
    setTheGroups(res.data[1]);
    setLoading(false);
  };

  //stock  // Priority ->
  const getIngredientStock = async (id) => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-closing-items/" + id;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setIngredientsStock(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // Helper
  const setFoodsStockReport = (res) => {
    setItemsFood(res.data[0]);
    setTheGroupsFood(res.data[1]);
    setLoading(false);
  };

  // Priority ->
  const getFoodStockReport = async (id) => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-closing-items-food/" + id;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setFoodsStockReport(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // Helper
  const setFoodsWeb = (res) => {
    setFoodListWeb(res.data[0]);
    setFoodGroupWeb(res.data[1]);
    setPropertyGroupWeb(res.data[2]);
    setWorkPeriodWeb(res.data[3]);
    setFoodStockWeb(res.data[[4]]);
  };

  //website
  //get foods web  // Priority ->
  const getFoodWeb = async () => {
    setLoading(true);
    const foodItemWebUrl = BASE_URL + "/website/home";
    try {
      const res = await axios.get(foodItemWebUrl);
      setFoodsWeb(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // Helper
  const setOnlineOrderCustomer = (res) => {
    setOnlineOrdersCustomer(res.data[1]);
    setLoading(false);
  };

  //get online orders customer  // Priority ->
  const getOnlineOrdersCustomer = async () => {
    setLoading(true);
    const ordersUrl = BASE_URL + "/website/online-orders/customer";
    try {
      const res = await axios.get(ordersUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setOnlineOrderCustomer(res);
      setDataToLocal(ordersUrl, res);
    } catch (error) {
      if (offline(ordersUrl)) {
        let parseRes = getDataFromLocal(ordersUrl);
        setOnlineOrderCustomer(parseRes);
      }
      setLoading(false);
    }
  };

  // Helper
  const setOlineOrderAdmin = (res) => {
    setOnlineOrdersAdmin(res.data[0]);
    setOnlineOrdersAdminForSearch(res.data[1]);
    setLoading(false);
  };

  //get online orders  // Priority ->
  const getOnlineOrders = async () => {
    setLoading(true);
    const ordersUrl = BASE_URL + "/website/online-orders";
    try {
      const res = await axios.get(ordersUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setOlineOrderAdmin(res);
      // setDataToLocal(ordersUrl, res);
    } catch (error) {
      // if (offline(ordersUrl)) {
      //   let parseRes = getDataFromLocal(ordersUrl);
      //   setOlineOrderAdmin(parseRes);
      // }
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedOnlineOrder = (res) => {
    setOnlineOrdersAdmin(res.data[0]);
    setOnlineOrdersAdminForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated online orders // Priority ->
  const setPaginatedOnlineOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/website/online-orders?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedOnlineOrder(res);
      // setDataToLocal(url, res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedOnlineOrder(parseRes);
      // }
      setDataPaginating(false);
    }
  };

  // Helper
  const setFoodPandaOrder= (res) => {
    setFoodPandaOrders(res.data[0]);
    setFoodPandaOrdersForSearch(res.data[1]);
    setLoading(false);
  };

  //get food panda orders  // Priority ->
  const getFoodPandaOrders = async () => {
    setLoading(true);
    const ordersUrl = BASE_URL + "/website/online-orders-fp";
    try {
      const res = await axios.get(ordersUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setFoodPandaOrder(res);
      // setDataToLocal(ordersUrl, res);
    } catch (error) {
      // if (offline(ordersUrl)) {
      //   let parseRes = getDataFromLocal(ordersUrl);
      //   setFoodPandaOrder(parseRes);
      // }
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedFoodPandaOrder = (res) => {
    setFoodPandaOrders(res.data[0]);
    setFoodPandaOrdersForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated food panda orders // Priority ->
  const setPaginatedPandaOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/website/online-orders-fp?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodPandaOrder(res);
      // setDataToLocal(url, res);
    } catch (error) {
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedFoodPandaOrder(parseRes);
      // }
      setDataPaginating(false);
    }
  };
  
  // Helper
  const setPreOrder= (res) => {
    setPreOrders(res.data[0]);
    setPreOrdersForSearch(res.data[1]);
    setLoading(false);
  };

  //get pre orders  // Priority ->
  const getPreOrders = async () => {
    setLoading(true);
    const ordersUrl = BASE_URL + "/website/get-pre-orders";
    try {
      const res = await axios.get(ordersUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPreOrder(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedPreOrder = (res) => {
    setPreOrders(res.data[0]);
    setPreOrdersForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated pre orders // Priority ->
  const setPaginatedPreOrders = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/website/get-pre-orders?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedPreOrder(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setPaginatedRegions = (res) => {
    setRegionList(res.data[0]);
    setRegionForSearch(res.data[1]);
    setRegionForStatus(res.data[2]);
    setDataPaginating(false);
  };

  const setPaginatedComments = (res) => {
    setCommentList(res.data[0]);
    setCommentForSearch(res.data[1]);
    setDataPaginating(false);
  };

  const setPaginatedCommentsType = (res) => {
    setCommentTypeList(res.data[0]);
    setCommentTypeForSearch(res.data[1]);
    setDataPaginating(false);
  };

  const setPaginatedSeasons = (res) => {
    setSeasonList(res.data[0]);
    setSeasonForSearch(res.data[1]);
    setSeasonForStatus(res.data[2]);
    setDataPaginating(false);
  };

  const setPaginatedGenerics = (res) => {
    setGenericList(res.data[0]);
    setGenericForSearch(res.data[1]);
    setGenericForStatus(res.data[2]);
    setDataPaginating(false);
  };

  const setPaginatedFlavors = (res) => {
    setFlavorList(res.data[0]);
    setFlavorForSearch(res.data[1]);
    setFlavorForStatus(res.data[2]);
    setDataPaginating(false);
  };

  const setPaginatedVariants = (res) => {
    setVariantList(res.data[0]);
    setVariantForSearch(res.data[1]);
    setVariantForStatus(res.data[2]);
    setDataPaginating(false);
  };

  const setPaginatedWeights = (res) => {
    setWeightList(res.data[0]);
    setWeightForSearch(res.data[1]);
    setWeightForStatus(res.data[2]);
    setDataPaginating(false);
  };
  const setPaginatedProductionUnits = (res) => {
    setProductionUnitList(res.data[0]);
    setProductionUnitForSearch(res.data[1]);
    setProductionUnitForStatus(res.data[2])
    setDataPaginating(false);
  };
  
  // Helper
  const setPaginatedSubCategories = (res) => {
    setSubCategoryList(res.data[0]);
    setSubCategoryForSearch(res.data[1]);
    setSubCategoryForStatus(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated sub category  // Priority ->
  const setPaginatedSubCategory = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-sub-category?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSubCategories(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPaginatedProductTypes = (res) => {
    setProductTypeList(res.data[0]);
    setProductTypeForSearch(res.data[1]);
    setProductTypeForStatus(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated product type  // Priority ->
  const setPaginatedProductType = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-type?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedProductTypes(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // get paginated region  // Priority ->
  const setPaginatedRegion = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/region?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedRegions(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // get paginated comments  // Priority ->
  const setPaginatedCommentType = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-comments-type?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedCommentsType(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // get paginated comments  // Priority ->
  const setPaginatedComment = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/comments?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedComments(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPaginatedSeason = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-item-season?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedSeasons(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPaginatedVariant = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-item-variant?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedVariants(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  const setPaginatedWeight = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-item-weight?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedWeights(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };
  
  const setPaginatedProductionUnit = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-unit-measure?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedProductionUnits(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };
  
  const setPaginatedGeneric = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-generic-setup?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedGenerics(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };
  const setPaginatedFlavor = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-flavour?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFlavors(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setPaginatedTaxGroups = (res) => {
    setTaxGroupList(res.data[0]);
    setTaxGroupForSearch(res.data[1]);
    setTaxGroupForStatus(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated tax  // Priority ->
  const setPaginatedTaxGroup = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/tax-group?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedTaxGroups(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setPaginatedItemPackingType = (res) => {
    setPackingTypeList(res.data[0]);
    setPackingTypeForSearch(res.data[1]);
    setPackingTypeForStatus(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated packing  // Priority ->
  const setPaginatedPackingType = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-packing?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedItemPackingType(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setPaginatedFoodStatuses = (res) => {
    setFoodStatusList(res.data[0]);
    setFoodStatusForSearch(res.data[1]);
    setFoodStatusForStatus(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated region  // Priority ->
  const setPaginatedFoodStatus = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/product-status?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodStatuses(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setFoods = (res) => {
    setFoodList(res.data[0]);
    setFoodForSearch(res.data[1]);
    setLoading(false)
  };

  //get foods  // Priority ->
  const getFood = async () => {
    setLoading(true);
    const endpoint = parseInt(getSystemSettings(generalSettings, "foods_in_setting")) ? "/settings/food-item-attributes?page=" : "/settings/get-food-item?page="
    const url = BASE_URL + endpoint;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setFoods(res);
      //setDataToLocal(url, res);
    } catch (error) {
      setLoading(false)
    }
  };

  // Helper
  const setPaginatedFoods = (res) => {
    setFoodList(res.data[0]);
    setFoodForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated food  // Priority ->
  const setPaginatedFood = async (pageNo) => {
    setDataPaginating(true);
    const endpoint = parseInt(getSystemSettings(generalSettings, "foods_in_setting")) ? "/settings/food-item-attributes?page=" : "/settings/get-food-item?page="
    const url = BASE_URL + endpoint + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoods(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedFoods(parseRes);
      // }
    }
  };

  // Helper
  const setPaginatedMeals = (res) => {
    setMealTimeList(res.data[0]);
    setMealTimeForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated meal  // Priority ->
  const setPaginatedMeal = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/meal-times?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedMeals(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setPaginatedFoodsDept = (res) => {
    setFoodDeptList(res.data[0]);
    setFoodDeptForSearch(res.data[1]);
    setFoodDeptForStatus(res.data[2]);
    setDataPaginating(false);
  };

  // get food dept  // Priority ->
  const getFoodDept = async () => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/food-department";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodsDept(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // get paginated food dept  // Priority ->
  const setPaginatedFoodDept = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/food-department?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodsDept(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // get food groups food items
  const getFoodGroupWithMenu = () => {
    const url = BASE_URL + "/settings/get-food-group-with-menu";
    axios
      .get(url, { headers: { Authorization: `Bearer ${getCookie()}` } })
      .then((res) => {
        setAvailableFoodGroups(res.data);
        setDataToLocal(url, res);
        // save to ls
      })
      .catch((err) => {
        // pwa work
        setLoading(false);
        if (offline(url)) {
          let parseRes = getDataFromLocal(url);
          parseRes && setAvailableFoodGroups(parseRes.data);
        }
      });
  };

  const setFoodItemRes = (data) =>{
    setFoodForPOS(data[1]);
    if (data[1] && data[1].length) {
      setMenuForPos(parseFoodItems(data[1]));
    }
    setIsStockLoading(false);
  }

  //get food items for POS  // Priority ->
  const getFoodItemsForPOS = async (toSetLoading = false) => {
    if (!toSetLoading) setIsStockLoading(true);
    const url = BASE_URL + "/settings/get-enabled-item";
    const res = await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodItemRes(res.data);
        setIsStockLoading(false);
        setDataToLocal(url, res);
      })
      .catch((error) => {
        setIsStockLoading(false);
        if (offline(url)) {
          let parseRes = getDataFromLocal(url);
          parseRes && setFoodForPOS(parseRes.data[1]);
          // setFoods(parseRes.data[1]);
        }
      });
  };

  //get food items for POS stock qty on call center  // Priority ->
  const getFoodItemsForCallCenter = async (id = null) => {
    // Abort previous request if it's still pending
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    // Create new AbortController for this request
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsStockLoading(true);
    const url = BASE_URL + "/settings/get-enabled-item-branch/" + id;
    const res = await axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
        signal: controller.signal
      })
      .then((res) => {
        setFoodItemRes(res.data);
        setIsStockLoading(false);
        setDataToLocal(url, res);
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log('Request canceled due to race condition:', error.message);
          return; // Do not update state if request was cancelled
        }
        console.log("abcd6",url)
        if (offline(url)) {
          setIsStockLoading(false);
          let parseRes = getDataFromLocal(url);
          parseRes && setFoodForPOS(parseRes.data[1]);
          // setFoods(parseRes.data[1]);
        }
      });
  };
  
  // Helper
  const setFoodsGroup = (res) => {
    setFoodGroupList(res?.data[0]);
    setFoodGroupforSearch(res?.data[1]);
    setFoodItemStock(res?.data[2]);
    setLoading(false);
  };

  //get food groups  // Priority
  const getFoodGroup = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-food-group";
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodsGroup(res);
        setDataToLocal(url, res);
      })
      .catch((error) => {
        setLoading(false);
        if (offline(url)) {
          let parseRes = getDataFromLocal(url);
          setFoodsGroup(parseRes);
        }
      });
  };

  const setFoodGroupForPos = (res) =>{
    const resData = Array.isArray(res?.data?.[1]) ? res.data?.[1] : res?.data;
    setFoodGroupforSearchForPOS(resData);
    const foodGroupForPos = (resData) && (resData).reduce((acc, item) => {
      acc.byId[item.id] = item;
      acc.byName[item.name] = item;
      return acc;
    },{ byId: {}, byName: {} });
    setFoodGroupForPOSById(foodGroupForPos?.byId);
    setAvailableFoodGroupName(foodGroupForPos?.byName)
    setLoading(false);
  }

  const getFoodGroupForPOS = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-food-group_status";
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodGroupForPos(res);
        setLoading(false);
        setDataToLocal(url, res);
      })
      .catch((error) => {
        setLoading(false);
        if (offline(url)) {
          let parseRes = getDataFromLocal(url);
          setFoodGroupForPos(parseRes);
        }
      });
  };

  // Helper
  const setPaginatedFoodsGroup = (res) => {
    setFoodGroupList(res.data[0]);
    setFoodGroupforSearch(res.data[1]);
    setFoodItemStock(res.data[2]);
    setDataPaginating(false);
  };

  // get paginated food groups  // Priority ->
  const setPaginatedFoodGroup = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-food-group?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodsGroup(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedFoodsGroup(parseRes);
      // }
    }
  };

  //Helper
  const setFoodsUnit = (res) => {
    setFoodUnitList(res.data[0]);
    setFoodUnitforSearch(res.data[1]);
    setLoading(false);
  };

  //get food units  // Priority ->
  const getFoodUnit = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-food-unit";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setFoodsUnit(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedFoodsUnit = (res) => {
    setFoodUnitList(res.data[0]);
    setFoodUnitforSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated food units // Priority ->
  const setPaginatedFoodUnit = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-food-unit?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodsUnit(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  // Helper
  const setVariationsList = (res) => {
    setVariationList(res?.data[0]);
    setVariationForSearch(res?.data[1]);
    setLoading(false);
  };

  //get variations  //Priority ->
  const getVariation = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-variation";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setVariationsList(res);
      setDataToLocal(url, res);
    } catch (error) {
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        setVariationsList(parseRes);
      }
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedVariations = (res) => {
    setVariationList(res.data[0]);
    setVariationForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated variations  // Priority ->
  const setPaginatedVariation = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-variation?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedVariations(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedVariations(parseRes);
      // }
    }
  };

  // Helper
  const setPropertyGroups = (res) => {
    setPropertyGroupList(res.data[0]);
    setPropertyGroupForSearch(res.data[1]);
    const propertyGroups = Array.isArray(res.data[1]) && res.data[1].reduce((acc, item) => {
      acc[item.id] = { ...item };
      return acc;
    }, {});
    setPropertyGroupById(propertyGroups)
    setLoading(false);
  };

  //get property group  // Priority ->
  const getPropertyGroup = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-property-group";
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPropertyGroups(res);
      setDataToLocal(url, res);
    } catch (error) {
      if (offline(url)) {
        let parseRes = getDataFromLocal(url);
        parseRes && setPropertyGroups(parseRes);
      }
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedPropertiesGroup = (res) => {
    setPropertyGroupList(res.data[0]);
    setPropertyGroupForSearch(res.data[1]);
    const propertyGroups = Array.isArray(res.data[1]) && res.data[1].reduce((acc, item) => {
      acc[item.id] = { ...item };
      return acc;
    }, {});
    setPropertyGroupById(propertyGroups)
    setDataPaginating(false);
  };

  // get paginated property group  // Priority ->
  const setPaginatedPropertyGroup = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-property-group?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedPropertiesGroup(res);
      // setDataToLocal(url, res);
    } catch (error) {
      setDataPaginating(false);
      // if (offline(url)) {
      //   let parseRes = getDataFromLocal(url);
      //   setPaginatedPropertiesGroup(parseRes);
      // }
    }
  };

  // Helper
  const setPropertyItems = (res) => {
    setPropertyItemList(res.data[0]);
    setPropertyItemForSearch(res.data[0]);
    setPropertyItemGroup(res.data[1]);
    setLoading(false);
  };

  //get property item  // Priority ->
  const getPropertyItem = async (slug) => {
    setLoading(true);
    //const propertyItemUrl = BASE_URL + "/settings/get-property-item/" + slug;
    //Change fahad //
    const propertyItemUrl = BASE_URL + "/settings/get-property-item/" + slug;
    try {
      const res = await axios.get(propertyItemUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPropertyItems(res);
      setDataToLocal(propertyItemUrl, res);
    } catch (error) {
      if (offline(propertyItemUrl)) {
        let parseRes = getDataFromLocal(propertyItemUrl);
        parseRes && setPropertyItems(parseRes);
      }
      setLoading(false);
    }
  };

  // Helper
  const setFoodsPurchase = (res) => {
    setFoodPurchaseHistory(res.data[0]);
    setFoodPurchaseHistoryForSearch(res.data[1]);
    setLoading(false);
  };

  //get food purchases  // Priority ->
  const getFoodPurchase = async () => {
    setLoading(true);
    const url = BASE_URL + "/settings/get-food_purchase";
    try {
      const res = await axios.get(url);
      setFoodsPurchase(res);
    } catch (error) {
      setLoading(false);
    }
  };

  // Helper
  const setPaginatedFoodsPurchase = (res) => {
    setFoodPurchaseHistory(res.data[0]);
    setFoodPurchaseHistoryForSearch(res.data[1]);
    setDataPaginating(false);
  };

  // get paginated purchases  // Priority ->
  const setPaginatedFoodPurchase = async (pageNo) => {
    setDataPaginating(true);
    const url = BASE_URL + "/settings/get-food_purchase?page=" + pageNo;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      setPaginatedFoodsPurchase(res);
    } catch (error) {
      setDataPaginating(false);
    }
  };

  //Get Order Detail  // Priority ->
  async function getOrderDetails(id) {
    const endPoint = "/settings/get-order/" + id;
    const url = getApiUrl(endPoint,authUserInfo,generalSettings);

    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then(async (res) => {
        console.log("indexOrder", res);
        return Promise.resolve(res.data.data[0]);
      })
      .catch(async (error) => {
        // if (offline(url)) {
        //   let parseRes = getDataFromLocal(url);
        //   setGetOrderDetails(parseRes);
        //   return Promise.resolve(parseRes.data.data[0]);
        // }
        if(error?.response?.data){
          toast.error(error.response.data?.message);
          if(error.response.data?.status === 1){
            sessionStorage.setItem("skipApi", "true");
            history.push("/dashboard/pos/submitted");
          }
        }
      });
  }

  return (
    <FoodContext.Provider
      value={{
        // common
        loading,
        setLoading,

        //ingredient stock
        getIngredientStock,
        items,
        setItems,
        theGroups,
        setTheGroups,

        //food stock
        getFoodStockReport,
        itemsFood,
        setItemsFood,
        theGroupsFood,
        setTheGroupsFood,

        //website
        getFoodWeb,
        foodGroupWeb,
        foodListWeb,
        setFoodListWeb,
        foodStockWeb,
        setFoodStockWeb,
        propertyGroupWeb,
        setPropertyGroupWeb,
        workPeriodWeb,
        onlineOrdersAdmin,
        setOnlineOrdersAdmin,
        onlineOrdersAdminForSearch,
        setOnlineOrdersAdminForSearch,
        getOnlineOrders,
        setPaginatedOnlineOrders,
        getOnlineOrdersCustomer,
        onlineOrdersCustomer,
        setOnlineOrdersCustomer,

        //food panda
        getFoodPandaOrders,
        setPaginatedPandaOrders,
        setFoodPandaOrders,
        setFoodPandaOrdersForSearch,
        foodPandaOrders,
        foodPandaOrdersForSearch,

        //pre order
        getPreOrders,
        setPaginatedPreOrders,
        setPreOrders,
        setPreOrdersForSearch,
        preOrders,
        preOrdersForSearch,

        //meal
        mealTimeList, 
        setMealTimeList,
        mealTimeForSearch,
        setMealTimeForSearch,
        setPaginatedMeal,

        //food
        getFood,
        foodList,
        setFoodList,
        setPaginatedFood,
        foodForSearch,
        setFoodForSearch,

        //food dept
        foodDeptList,
        setFoodDeptList,
        foodDeptForSearch, 
        setFoodDeptForSearch,
        foodDeptForStatus,
        setFoodDeptForStatus,
        getFoodDept,
        setPaginatedFoodDept,

        //sub category
        subCategoryList, 
        setSubCategoryList,
        subCategoryForSearch, 
        setSubCategoryForSearch,
        subCategoryForStatus,
        setSubCategoryForStatus,
        setPaginatedSubCategory,

        //product type
        setPaginatedProductType,
        productTypeList, 
        setProductTypeList,
        productTypeForSearch, 
        setProductTypeForSearch,
        productTypeForStatus, 
        setProductTypeForStatus,

        //comment type
        commentTypeList, 
        setCommentTypeList,
        commentTypeForSearch, 
        setCommentTypeForSearch,
        setPaginatedCommentType,

        //comments
        setPaginatedComment,
        commentList,
        setCommentList,
        commentForSearch,
        setCommentForSearch,

        //region
        setPaginatedRegion,
        regionList,
        setRegionList,
        regionForSearch,
        setRegionForSearch,
        regionForStatus, 
        setRegionForStatus,
        
        //Variant
        setPaginatedVariant,
        variantList,
        setVariantList,
        variantForSearch,
        setVariantForSearch,
        variantForStatus, 
        setVariantForStatus,

        //weight
        setPaginatedWeight,
        weightList,
        setWeightList,
        weightForSearch,
        setWeightForSearch,
        weightForStatus, 
        setWeightForStatus,

        //season
        setPaginatedSeason,
        seasonList,
        setSeasonList,
        seasonForSearch,
        setSeasonForSearch,
        seasonForStatus, 
        setSeasonForStatus,

        //generic
        setPaginatedGeneric,
        genericList, 
        setGenericList,
        genericForSearch,
        setGenericForSearch,
        genericForStatus, 
        setGenericForStatus,

        //flavour
        setPaginatedFlavor,
        flavorList, 
        setFlavorList,
        flavorForSearch,
        setFlavorForSearch,
        flavorForStatus, 
        setFlavorForStatus,

        //tax group
        taxGroupList, 
        setTaxGroupList,
        taxGroupForSearch, 
        setTaxGroupForSearch,
        taxGroupForStatus, 
        setTaxGroupForStatus,
        setPaginatedTaxGroup,

        //Production Unit
        setPaginatedProductionUnit,
        productionUnitList, 
        setProductionUnitList,
        productionUnitForSearch,
        setProductionUnitForSearch,
        productionUnitForStatus, 
        setProductionUnitForStatus,

        //packing type
        packingTypeList, 
        setPackingTypeList,
        packingTypeForSearch,
        setPackingTypeForSearch,
        packingTypeForStatus,
        setPackingTypeForStatus,
        setPaginatedPackingType,

        //food status
        foodStatusList, 
        setFoodStatusList,
        foodStatusForSearch, 
        setFoodStatusForSearch,
        foodStatusForStatus, 
        setFoodStatusForStatus,
        setPaginatedFoodStatus,
        
        //food for POS
        getFoodItemsForPOS,
        getFoodItemsForCallCenter,
        setFoodForPOS,
        foodForPOS,
        menuForPos,

        //food purchases
        getFoodPurchase,
        foodPurchaseHistory,
        setFoodPurchaseHistory,
        setPaginatedFoodPurchase,
        foodPurchaseHistoryForSearch,
        setFoodPurchaseHistoryForSearch,

        //stock
        foodItemStock,
        //food group
        getFoodGroup,
        foodGroupList,
        setFoodGroupList,
        setPaginatedFoodGroup,
        foodGroupForSearch,
        setFoodGroupforSearch,
        getFoodGroupForPOS,
        foodGroupForSearchForPOS,
        foodGroupForPOSById,
        setFoodGroupforSearchForPOS,
        //food units
        getFoodUnit,
        foodUnitList,
        setFoodUnitList,
        setPaginatedFoodUnit,
        foodUnitForSearch,
        setFoodUnitforSearch,

        //variation
        getVariation,
        variationList,
        setVariationList,
        setPaginatedVariation,
        variationForSearch,
        setVariationForSearch,

        //property group
        getPropertyGroup,
        propertyGroupList,
        setPropertyGroupList,
        setPaginatedPropertyGroup,
        propertyGroupForSearch,
        setPropertyGroupForSearch,
        propertyGroupById,
        
        //property Item
        getPropertyItem,
        propertyItemList,
        setPropertyItemList,
        propertyItemForSearch,
        setPropertyItemForSearch,
        propertyItemGroup,
        setPropertyItemGroup,
        // propertyGroupById,
        //pagination
        dataPaginating,
        setDataPaginating,

        getOrderDetails,

        //food group menu
        availableFoodGroups,
        setAvailableFoodGroups,
        availableFoodGroupName,
        getFoodGroupWithMenu,
        isStockLoading,
      }}
    >
      {children}
    </FoodContext.Provider>
  );
};

export { FoodContext, FoodProvider };
